query allEvents(
  $first: Int,
  $offset: Int,
  $filter: EventFilter,
  $condition: EventCondition,
) {
  events: allEvents(
    first: $first,
    offset: $offset,
    filter: $filter,
    condition: $condition,
    orderBy: STARTS_AT_ASC
  ) {
    nodes {
      eventName
      eventId
      startsAt
      competition {
        competitionName
      }
      isUsaView
    }
    totalCount
  }
}
